import { STATUS_CODE } from '@kc-console/core';

import {
  SB_HOST_QUERY_KEY,
  STATUS_BOARD_LNB_COLLAPSED_COOKIE,
} from '../../../constants/guards/status-board';
import { parseCookies } from '../../../utils/cookie/parseCookies';

import type { BaseState } from '@kc-console/context';
import type { Guard } from '../../../types';

const parseLnbCollapsedFromCookieHeader = (cookieHeader: string | undefined) => {
  const cookies = parseCookies(cookieHeader || '');
  return cookies[STATUS_BOARD_LNB_COLLAPSED_COOKIE] === 'true';
};

/**
 * 요청 쿠키의 LNB 접힘/펼침 상태를 확인하여 세팅
 */
export const determineLnbCollapsedGuard: Guard<BaseState> = async ({ context, queryClient }) => {
  const collapsed = parseLnbCollapsedFromCookieHeader(context.req.headers.cookie);
  queryClient.setQueryData([SB_HOST_QUERY_KEY.GET_LNB_COLLAPSED], collapsed);
  return { status: STATUS_CODE.OK };
};

determineLnbCollapsedGuard.displayName = 'determineLnbCollapsedGuard';
